module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_3.a44793ec.png";